(() => {
  class ProductPageController extends Stimulus.Controller {
    static values = {
      skipInitialImage: { type: Boolean, default: false }
    };

    static targets = ['selectedVariant'];

    connect() {
      this.isInitialLoad = true;
      this.onVariantChanged();
      this.isInitialLoad = false;
    }

    findSelectedVariantId() {
      return this.selectedVariantTarget.value;
    }

    findSelectedVariantImageId() {
      const selectedOption = this.selectedVariantTarget.selectedOptions[0];

      return selectedOption?.dataset.imageId || null;
    }

    onVariantChanged() {
      this.updateUrl();
      this.updateMainImage();
    }

    updateUrl() {
      const variantId = this.findSelectedVariantId();
      UrlService.addOrUpdateUrlParam('variant', variantId);
    }

    updateMainImage() {
      // Skip initial image update if configured (used for custom hero images)
      if (this.isInitialLoad && this.skipInitialImageValue) {
        return;
      }

      const variantImageId = this.findSelectedVariantImageId();

      window.dispatchEvent(
        new CustomEvent('product-image-changed', {
          detail: {
            mediaId: variantImageId
          }
        })
      );
    }
    }

  document.addEventListener('DOMContentLoaded', () => {
    if (window.StimulusApp) {
      window.StimulusApp.register("product-page", ProductPageController);
    } else if (window.Stimulus && window.Stimulus.Application) {
      const application = window.Stimulus.Application.defaultApplication;
      if (application) {
        application.register("product-page", ProductPageController);
      } else {
        console.error('Stimulus application instance not found');
      }
    } else {
      console.error('Stimulus not found');
    }
  });
})();
